var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { staticClass: "q-mb-md" },
    [
      _c(
        "q-collapsible",
        {
          attrs: { icon: "fal fa-filter", label: _vm.getNameFilter },
          on: { click: _vm.toggle },
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _vm.options
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _vm.options.user_areas && _vm.options.user_areas.length
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("select-multiple", {
                          attrs: {
                            label: "areas",
                            filters: _vm.filters.user_area,
                            options: _vm.options.user_areas
                          },
                          on: {
                            on_value: function($event) {
                              _vm.filters.user_area = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.profiles
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            options: _vm.options.profiles,
                            multiple: "",
                            "float-label": _vm.$t("profiles"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.profile,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "profile", $$v)
                            },
                            expression: "filters.profile"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.statuses
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.statuses,
                            "float-label": _vm.$t("status"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.status,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.has_filter_companies
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "q-chips-input",
                          {
                            attrs: {
                              "float-label":
                                _vm.$t("headquarter") +
                                " (" +
                                _vm.filters.companies_label.length +
                                ")",
                              placeholder: _vm.$t(
                                "enter_the_company_or_chain_name"
                              )
                            },
                            on: { remove: _vm.removeHeadquarter },
                            model: {
                              value: _vm.filters.companies_label,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "companies_label", $$v)
                              },
                              expression: "filters.companies_label"
                            }
                          },
                          [
                            _c("q-autocomplete", {
                              attrs: {
                                debounce: 500,
                                "min-characters": 1,
                                "max-results": 100
                              },
                              on: {
                                search: _vm.fetchHeadquarters,
                                selected: _vm.selectHeadquarter
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.has_filter_store
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "q-chips-input",
                          {
                            attrs: {
                              "float-label":
                                _vm.$t("branch") +
                                " (" +
                                _vm.filters.company_branches_label.length +
                                ")",
                              placeholder: _vm.$t(
                                "enter_the_store_or_branch_name"
                              )
                            },
                            on: { remove: _vm.removeBranch },
                            model: {
                              value: _vm.filters.company_branches_label,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.filters,
                                  "company_branches_label",
                                  $$v
                                )
                              },
                              expression: "filters.company_branches_label"
                            }
                          },
                          [
                            _c("q-autocomplete", {
                              attrs: {
                                debounce: 500,
                                "min-characters": 3,
                                "max-results": 100
                              },
                              on: {
                                search: _vm.fetchBranches,
                                selected: _vm.selectBranch
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("clear_filters"),
                    icon: "far fa-eraser"
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearFilter()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("apply_filter_plural"),
                    icon: "far fa-filter"
                  },
                  on: {
                    click: function($event) {
                      return _vm.requestFiltered()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }